import React, { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    FormControlLabel,
    Checkbox,
    useTheme,
    IconButton,
} from "@mui/material";
import { addRole, updateRole } from "state/apis";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";

const AddRoleForm = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [data, setData] = useState({
        name: "",
        permission: {
            role: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            user: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            owner: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            property: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            unit: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            expenseType: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            tenant: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            contract: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            receipt: {
                add: false,
                update: false,
                delete: false,
                view: false,
                editDate: false,
            },
            expense: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            commonExpense: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            employee: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
            search: {
                view: false,
            },
            report: {
                view: false,
            },
            voucherReceipt: {
                view: false,
                delete: false,
            },
            paymentVoucher: {
                view: false,
                delete: false,
            },
            rentDispute: {
                view: false,
            },
            snapshot: {
                view: false,
                delete: false,
            },
            soldProperty: {
                add: false,
                update: false,
                delete: false,
                view: false,
            },
        },
    });

    useEffect(() => {
        if (editMode && editData) {
            editData.permission = JSON.parse(editData.permission);
            setData(editData);
        } else {
            setData({
                name: "",
                permission: {
                    role: { add: false, update: false, delete: false, view: false },
                    user: { add: false, update: false, delete: false, view: false },
                    owner: { add: false, update: false, delete: false, view: false },
                    property: { add: false, update: false, delete: false, view: false },
                    unit: { add: false, update: false, delete: false, view: false },
                    expenseType: { add: false, update: false, delete: false, view: false },
                    tenant: { add: false, update: false, delete: false, view: false },
                    contract: { add: false, update: false, delete: false, view: false },
                    receipt: { add: false, update: false, delete: false, view: false, editDate: false },
                    expense: { add: false, update: false, delete: false, view: false },
                    commonExpense: { add: false, update: false, delete: false, view: false },
                    employee: { add: false, update: false, delete: false, view: false },
                    search: { view: false },
                    report: { view: false },
                    voucherReceipt: { view: false, delete: false },
                    paymentVoucher: { view: false, delete: false },
                    rentDispute: { update: false, view: false },
                    snapshot: { view: false, delete: false },
                    soldProperty: { add: false, update: false, delete: false, view: false },
                },
            });
        }
    }, [editData, editMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handlePermissionChange = (entity, permissionType) => (e) => {
        setData((prevData) => ({
            ...prevData,
            permission: {
                ...prevData.permission,
                [entity]: {
                    ...prevData.permission[entity],
                    [permissionType]: e.target.checked,
                },
            },
        }));
    };

    const handleSubmit = async () => {
        try {
            if (editMode) {
                const response = await updateRole(data.id, data);
                toast.success(response.message);
            } else {
                const response = await addRole(data);
                toast.success(response.message);
            }
            onSubmit();
            onClose();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                {editMode ? "Edit Role" : "Add Role"}
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Name"
                            name="name"
                            value={data.name}
                            onChange={handleChange}
                        />
                    </Grid>
                    {/* Permissions for Role */}
                    <Grid container item xs={12} alignItems="center" pt={"0"}>
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Roles</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.role?.add}
                                        onChange={handlePermissionChange("role", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.role.update}
                                        onChange={handlePermissionChange("role", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.role.delete}
                                        onChange={handlePermissionChange("role", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.role.view}
                                        onChange={handlePermissionChange("role", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>

                    {/* Permissions for Users */}
                    <Grid container item xs={12} alignItems="center" pt={"0"}>
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Users</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.user.add}
                                        onChange={handlePermissionChange("user", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.user.update}
                                        onChange={handlePermissionChange("user", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.user.delete}
                                        onChange={handlePermissionChange("user", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.user.view}
                                        onChange={handlePermissionChange("user", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>

                    {/* Permissions for Owner */}
                    <Grid container item xs={12} alignItems="center" pt={"0"}>
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Owners</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.owner.add}
                                        onChange={handlePermissionChange("owner", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.owner.update}
                                        onChange={handlePermissionChange("owner", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.owner.delete}
                                        onChange={handlePermissionChange("owner", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.owner.view}
                                        onChange={handlePermissionChange("owner", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>

                    {/* Permissions for Property */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Properties</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.property.add}
                                        onChange={handlePermissionChange("property", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.property.update}
                                        onChange={handlePermissionChange("property", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.property.delete}
                                        onChange={handlePermissionChange("property", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.property.view}
                                        onChange={handlePermissionChange("property", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for Units */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Units</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.unit.add}
                                        onChange={handlePermissionChange("unit", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.unit.update}
                                        onChange={handlePermissionChange("unit", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.unit.delete}
                                        onChange={handlePermissionChange("unit", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.unit.view}
                                        onChange={handlePermissionChange("unit", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for expenseType */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Expense Type</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.expenseType.add}
                                        onChange={handlePermissionChange("expenseType", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.expenseType.update}
                                        onChange={handlePermissionChange("expenseType", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.expenseType.delete}
                                        onChange={handlePermissionChange("expenseType", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission.expenseType.view}
                                        onChange={handlePermissionChange("expenseType", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>

                    {/* Permissions for tenants */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Tenants</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.tenant?.add}
                                        onChange={handlePermissionChange("tenant", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.tenant?.update}
                                        onChange={handlePermissionChange("tenant", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.tenant?.delete}
                                        onChange={handlePermissionChange("tenant", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.tenant?.view}
                                        onChange={handlePermissionChange("tenant", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>

                    {/* Permissions for contract */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Contract</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.contract?.add}
                                        onChange={handlePermissionChange("contract", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.contract?.update}
                                        onChange={handlePermissionChange("contract", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.contract?.delete}
                                        onChange={handlePermissionChange("contract", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.contract?.view}
                                        onChange={handlePermissionChange("contract", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for Receipt */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Receipt</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.receipt?.add}
                                        onChange={handlePermissionChange("receipt", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.receipt?.update}
                                        onChange={handlePermissionChange("receipt", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.receipt?.delete}
                                        onChange={handlePermissionChange("receipt", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.receipt?.view}
                                        onChange={handlePermissionChange("receipt", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={!!data?.permission?.receipt?.editDate}
                                        onChange={handlePermissionChange("receipt", "editDate")}
                                        color="primary"
                                    />
                                }
                                label="Edit Date"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for expense */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Expense </h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.expense?.add}
                                        onChange={handlePermissionChange("expense", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.expense?.update}
                                        onChange={handlePermissionChange("expense", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.expense?.delete}
                                        onChange={handlePermissionChange("expense", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.expense?.view}
                                        onChange={handlePermissionChange("expense", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for commonExpense */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Common Expense </h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.commonExpense?.add}
                                        onChange={handlePermissionChange("commonExpense", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.commonExpense?.update}
                                        onChange={handlePermissionChange("commonExpense", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.commonExpense?.delete}
                                        onChange={handlePermissionChange("commonExpense", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.commonExpense?.view}
                                        onChange={handlePermissionChange("commonExpense", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for search */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Search </h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.search?.view}
                                        onChange={handlePermissionChange("search", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for report */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Report </h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.report?.view}
                                        onChange={handlePermissionChange("report", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for voucherReceipt */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Voucher Receipt </h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.voucherReceipt?.view}
                                        onChange={handlePermissionChange("voucherReceipt", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.voucherReceipt?.delete}
                                        onChange={handlePermissionChange(
                                            "voucherReceipt",
                                            "delete"
                                        )}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for rentDispute */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Rent Dispute</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.rentDispute?.view}
                                        onChange={handlePermissionChange("rentDispute", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.rentDispute?.update}
                                        onChange={handlePermissionChange("rentDispute", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for employee */}
                    <Grid container item xs={12} alignItems="center" pt={"0"}>
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Employee</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.employee?.add}
                                        onChange={handlePermissionChange("employee", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.employee?.update}
                                        onChange={handlePermissionChange("employee", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.employee?.delete}
                                        onChange={handlePermissionChange("employee", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.employee?.view}
                                        onChange={handlePermissionChange("employee", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for payment voucher */}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Payment Voucher</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.paymentVoucher?.view}
                                        onChange={handlePermissionChange("paymentVoucher", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.paymentVoucher?.delete}
                                        onChange={handlePermissionChange(
                                            "paymentVoucher",
                                            "delete"
                                        )}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for snapshot*/}
                    <Grid container item xs={12} alignItems="center">
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Position reports</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.snapshot?.view}
                                        onChange={handlePermissionChange("snapshot", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data?.permission?.snapshot?.delete}
                                        onChange={handlePermissionChange("snapshot", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                    </Grid>
                    {/* Permissions for employee */}
                    <Grid container item xs={12} alignItems="center" pt={"0"}>
                        <Grid item xs={12}>
                            <h4 style={{ margin: 0 }}>Sold Property</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.soldProperty?.add}
                                        onChange={handlePermissionChange("soldProperty", "add")}
                                        color="primary"
                                    />
                                }
                                label="Add"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.soldProperty?.update}
                                        onChange={handlePermissionChange("soldProperty", "update")}
                                        color="primary"
                                    />
                                }
                                label="Update"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.soldProperty?.delete}
                                        onChange={handlePermissionChange("soldProperty", "delete")}
                                        color="primary"
                                    />
                                }
                                label="Delete"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.permission?.soldProperty?.view}
                                        onChange={handlePermissionChange("soldProperty", "view")}
                                        color="primary"
                                    />
                                }
                                label="View"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        {editMode ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default AddRoleForm;
